"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4194],{

/***/ 84194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content003": function() { return /* binding */ Content003; },
  "default": function() { return /* binding */ Content003_Content003; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/Poster/Poster.jsx
var Poster = __webpack_require__(81072);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content003/Content003.config.js

var TITLE_POSITIONS = {
    TOP: "top",
    BOTTOM: "bottom"
};
var _obj;
var POSITION_APPEARANCE_MAPPING = (_obj = {}, (0,_define_property/* default */.Z)(_obj, TITLE_POSITIONS.TOP, "default"), (0,_define_property/* default */.Z)(_obj, TITLE_POSITIONS.BOTTOM, "accent"), (0,_define_property/* default */.Z)(_obj, "default", "default"), _obj);

;// CONCATENATED MODULE: ./src/components/widgets/content/Content003/Content003.jsx



var Content003 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var image = (ref1 = payload === null || payload === void 0 ? void 0 : payload.media) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    var appearance = (ref2 = POSITION_APPEARANCE_MAPPING[payload === null || payload === void 0 ? void 0 : payload.titlePosition]) !== null && ref2 !== void 0 ? ref2 : POSITION_APPEARANCE_MAPPING["default"];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Poster/* Poster */.W, {
        image: image,
        title: title,
        appearance: appearance
    });
};
/* harmony default export */ var Content003_Content003 = (Content003);


/***/ })

}]);